export const SUPPLIER_COLORS = [
	"#1565c0",
	"#7b1fa2",
	"#ef6c00",
	"#3949ab",
	"#5d4037",
	"#0288d1",
	"#37474f",
	"#b28704",
];

export const SUPPLIER_FALLBACK_COLOR = "#9e9e9e";

export const getSupplierColorIndex = (supplier: string | null | undefined) => {
	if (!supplier) return -1;

	let hash = 0;
	for (let i = 0; i < supplier.length; i++) {
		hash = (hash * 31 + supplier.charCodeAt(i)) >>> 0;
	}
	return hash % SUPPLIER_COLORS.length;
};

export const getSupplierColor = (supplier: string | null | undefined) => {
	const index = getSupplierColorIndex(supplier);
	return index === -1 ? SUPPLIER_FALLBACK_COLOR : SUPPLIER_COLORS[index];
};

export const getSupplierInitial = (supplier: string | null | undefined) =>
	supplier?.trim().charAt(0).toUpperCase() || "?";
